import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import utils from '../utils/index.jsx';
import BigNumber from 'bignumber.js';
import { TronLinkAdapter } from '@tronweb3/tronwallet-adapters';


//import QRScanner from '../components/QRScanner.jsx';

const CONTRACT = utils.SC4.address;
const ABI_CONTRACT = utils.SC4.abi;
const ABI_TOKEN = utils.USDT.abi;
const tronWeb = utils.tronWeb;

const CONTRACT_TS = utils.SC5;
//const adapter = utils.adapter;

const imgLoading = <img src="assets/images/cargando.gif" height="20px" alt="loading..." />;

const LIMITE_ENERGY = 200000;

const defaultWallet = "T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb";

const tokenInicial = [
    {
        address: "41a614f803b6fd780986a42c78ec9c7f77e6ded13c",
        symbol: "USDT",
        name: "Tether USD",
        decimals: 6,
        fees: 0.5
    }
];

function CiroTrx() {
    /*const [qrResult, setQrResult] = useState("");

    const handleScanSuccess = result => {
        setQrResult(result);
    };*/

    const adapter = useMemo(() => new TronLinkAdapter(), []);

    const [estatus, setEstatus] = useState({ loggedIn: false });
    const [wallet, setWallet] = useState(defaultWallet);
    const [contractReady, setContractReady] = useState(false);
    const [contrato, setContrato] = useState({ web3: null, ciro_trx: null, sale_token: null ,tokenList: [] });
    const [tokenContratos, setTokenContratos] = useState(tokenInicial);
    const [idMoneda, setIdMoneda] = useState(0);
    const [tokenBalance, setTokenBalance] = useState(new BigNumber(0));
    const [tokenSelected, setTokenSelected] = useState("USDT");
    const [amountIn, setAmounIn] = useState("0")
    const [recivedAmount, setRecivedAmount] = useState("0");
    const [approved, setApproved] = useState(false);
    const [energyContrato, setEnergyContrato] = useState(0);
    const [energyWallet, setEnergyWallet] = useState(0);
    const [modalTitle, setModalTitle] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [porcentajeE, setPorcentajeE] = useState(new BigNumber(0));

    const amountInput = useRef();
    const walletInput = useRef();

    const intervalRef = useRef(null);
    const iniciado = useRef(false);

    const conectar = useCallback(async () => {
        //if (typeof window.tronWeb === 'undefined') return;

        try {
            await adapter.connect();
            const conectado = Boolean(adapter.address) && adapter.connected;
            const newWallet = conectado ? adapter.address : defaultWallet;
            const tronWeb_c = tronWeb;
            tronWeb_c.setAddress(newWallet);

            setEstatus({ loggedIn: conectado });
            setWallet(newWallet);
            setContrato(prev => ({ ...prev, web3: tronWeb_c }));

            if (!iniciado.current && !contractReady) {
                iniciado.current = true;
                const contratoInstancia = tronWeb_c.contract(ABI_CONTRACT, CONTRACT);

                const contratoInstancia2 = tronWeb_c.contract(CONTRACT_TS.abi,CONTRACT_TS.address);
                contratoInstancia2.token = tronWeb_c.contract(ABI_TOKEN, await contratoInstancia2.paymentToken().call());

                const tokenListData = await contratoInstancia.viewTokenList().call();
                const tokenAddresses = tokenListData[0];
                const tokenFees = tokenListData[2];

                const tokenInstances = await Promise.all(
                    tokenAddresses.map((addr) => tronWeb_c.contract(ABI_TOKEN, addr))
                );
                setContrato(prev => ({ ...prev, ciro_trx: contratoInstancia, tokenList: tokenInstances, sale_token: contratoInstancia2 }));
                const tokenInfo = await Promise.all(
                    tokenAddresses.map(async (addr, index) => {
                        const contract = tronWeb_c.contract(ABI_TOKEN, addr);
                        const [symbol, name, decimals] = await Promise.all([
                            contract.symbol().call(),
                            contract.name().call(),
                            contract.decimals().call()
                        ]);

                        return {
                            address: addr,
                            symbol,
                            name,
                            decimals: parseInt(decimals),
                            fees: parseInt(tokenFees[index]) / 10 ** parseInt(decimals)
                        };
                    })
                );

                setTokenContratos(tokenInfo);
                setContractReady(true);
            }
        } catch (error) {
            console.error("Conexión fallida:", error);
            setModalTitle('Error');
            setModalBody(error.toString());
            window.$("#exampleModal").modal("show");
        }
        // eslint-disable-next-line
    }, [])

    const estado = useCallback(async () => {
        if (!contrato.tokenList[idMoneda]) return;
        const tokenInstance = contrato.tokenList[idMoneda];
        const contratoToken = tokenContratos[idMoneda];

        const balanceRaw = await tokenInstance.balanceOf(wallet).call();
        const balance = new BigNumber(balanceRaw).shiftedBy(-contratoToken.decimals);
        setTokenBalance(balance);
        setTokenSelected(contratoToken.symbol);

        const approvedRaw = await tokenInstance.allowance(wallet, CONTRACT).call();
        const approvedVal = new BigNumber(approvedRaw).shiftedBy(-contratoToken.decimals);
        setApproved(approvedVal.gte(balance));

        const recursosContrato = await tronWeb.trx.getAccountResources("TWVVi4x2QNhRJyhqa7qrwM4aSXnXoUDDwY");
        let energyAvailable = recursosContrato.EnergyLimit || 0;
        let energyUsed = recursosContrato.EnergyUsed || 0;
        let netEnergy = energyAvailable - energyUsed;

        const porcentaje = energyAvailable > 0 ? new BigNumber((netEnergy / energyAvailable) * 100) : new BigNumber(0);
        setPorcentajeE(porcentaje);
        setEnergyContrato(netEnergy);

        const recursosUsuario = await tronWeb.trx.getAccountResources(wallet);
        let energyWalletValue = (recursosUsuario.EnergyLimit || 0) - (recursosUsuario.EnergyUsed || 0);
        setEnergyWallet(energyWalletValue);

        const trxBalance = await tronWeb.trx.getUnconfirmedBalance(wallet);
        if (new BigNumber(trxBalance).isLessThanOrEqualTo(0)) {
            setModalTitle("Alert!");
            setModalBody("Need some TRX to pay bandwidth. Recharge at least 1 TRX.");
            window.$("#exampleModal").modal("show");
        }
    }, [contrato, idMoneda, tokenContratos, wallet])

    useEffect(() => {
        if (adapter.address) {
            setWallet(adapter.address);
        }

        const handleConnect = () => {
            if (adapter.address) {
                setWallet(adapter.address);
            }
        };

        const handleAccountsChanged = (address) => {
            setWallet(address);
        };

        const handleDisconnect = () => {
            alert("Tu wallet se ha desconectado");
            setWallet("");
        };

        adapter.on('connect', handleConnect);
        adapter.on('accountsChanged', handleAccountsChanged);
        adapter.on('disconnect', handleDisconnect);

        return () => {
            adapter.off('connect', handleConnect);
            adapter.off('accountsChanged', handleAccountsChanged);
            adapter.off('disconnect', handleDisconnect);
        };
    }, [adapter]);

    useEffect(() => {
        document.title = "Dapp | CiroTrx";
        const timeout = setTimeout(() => {
            //conectar();
        }, 3000);

        return () => clearTimeout(timeout);
    }, [conectar]);

    useEffect(() => {

        intervalRef.current = setInterval(() => {
            if (estatus.loggedIn && contractReady) estado();
        }, 30000);

        return () => clearInterval(intervalRef.current);

    }, [conectar, contractReady, estado, estatus.loggedIn, wallet, adapter.address]);

    useEffect(() => {
        if (contractReady && contrato.tokenList.length > 0 && wallet) {
            estado();
        }
    }, [idMoneda, contractReady, contrato.tokenList.length, wallet, estado]);

    useEffect(() => {

        let value = parseFloat(amountIn)

        if (value > tokenContratos[idMoneda].fees) {
            value -= tokenContratos[idMoneda].fees
        } else {
            value = 0
        }

        setRecivedAmount(value.toFixed(6))

    }, [amountIn, tokenContratos, idMoneda])

    const rentEnergy = async (requiredEnergy) => {
        const energyShortage = requiredEnergy - energyWallet;
        if (energyShortage <= 0) return true;
        const amountToRent = energyShortage < 32000 ? 32000 : energyShortage;

        const priceRes = await fetch( process.env.REACT_APP_BOT_URL + "prices", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ resource: "energy", amount: amountToRent, duration: "5min" })
        })
        .then(res => res.json())
        .catch(err => {console.log(err); return 0;});

        const price = parseFloat(priceRes?.price || 0);

        if (price === 0 || price === undefined){

            setModalTitle("Energy price error");
            setModalBody(`error request api energy`);
            window.$("#exampleModal").modal("show");

            return false;
        }

        if (price > (await contrato.web3.trx.getUnconfirmedBalance(wallet)) / 10 ** 6) {
            setModalTitle("Insufficient funds");
            setModalBody(`Requires at least ${price + 1} TRX to rent energy.`);
            window.$("#exampleModal").modal("show");
            return false;
        }

        setModalTitle("⚡ Energy Rental Required to Proceed");
        setModalBody(<>You currently have <b>{energyWallet.toLocaleString('en-US')}</b> energy available.<br></br>
            To approve the contract, you need <b>{amountToRent.toLocaleString('en-US')}</b>.<br></br>
            The platform will temporarily rent energy on your behalf to enable this approval.</>);
        window.$("#exampleModal").modal("show");

        const transaction = await tronWeb.transactionBuilder.sendTrx(
            process.env.REACT_APP_WALLET_API,
            (price * 10 ** 6).toString(10),
            adapter.address
        );

        const signed = await adapter.signTransaction(transaction).catch((e) => {
            setModalTitle("Transaction failed E-A01");
            setModalBody(e.toString());
            window.$("#exampleModal").modal("show");
            return null;
        });
        if (!signed) return false;

        const result = await utils.rentResource(wallet, "energy", amountToRent, "5", "min", price, signed);

        if (result.result && !result.error) {
            setModalTitle("Completed successfully");
            setModalBody("Energy rental completed successfully.");
        } else {
            setModalTitle("Contact support");
            setModalBody("Please contact support for: " + result.hash + " | " + result.msg);
        }
        window.$("#exampleModal").modal("show");
        return result.result;
    };

    const handleApproval = async () => {
        const tokenInfo = tokenContratos[idMoneda];
        const tokenAddress = tokenInfo.address;
        const spender = window.tronWeb.address.toHex(CONTRACT);
        const maxUint = "115792089237316195423570985008687907853269984665640564039457584007913129639935";

        const energyCheck = await tronWeb.transactionBuilder.triggerConstantContract(
            tokenAddress,
            "approve(address,uint256)",
            {},
            [
                { type: 'address', value: spender },
                { type: 'uint256', value: maxUint }
            ],
            window.tronWeb.address.toHex(wallet)
        );

        let energyNeeded = energyCheck.energy_used || 0;
        energyNeeded += energyCheck.energy_penalty || 0;

        const canRent = await rentEnergy(energyNeeded);
        if (!canRent) return;

        setModalTitle("📝 Approve Contract");
        setModalBody(<>
            Grant unlimited {tokenInfo.symbol} spending permission to the contract.
            This lets you send transactions without needing TRX.<br></br>
            <br></br>
            <b><span role='img' aria-label="mano">👉</span> Trust the contract and use the default amount.</b>
        </>);
        window.$("#exampleModal").modal("show");

        const trigger = await tronWeb.transactionBuilder.triggerSmartContract(
            tokenAddress,
            "approve(address,uint256)",
            {},
            [
                { type: 'address', value: spender },
                { type: 'uint256', value: maxUint }
            ],
            window.tronWeb.address.toHex(wallet)
        );

        let tx = await tronWeb.transactionBuilder.extendExpiration(trigger.transaction, 180);
        tx = await adapter.signTransaction(tx).catch((e) => {
            setModalTitle("Error A02");
            setModalBody(e.toString());
            window.$("#exampleModal").modal("show");
        });
        if (!tx) return;

        const sentTx = await tronWeb.trx.sendRawTransaction(tx);
        console.log(sentTx)
        if (sentTx?.txid) {
            setApproved(true);
            setModalTitle("Correct");
            setModalBody(<>
                Your approval is done.<br />
                <a href={`https://tronscan.org/#/transaction/${sentTx.txid}`} target="_blank" rel="noopener noreferrer">See on TronScan</a>
            </>);
        } else {
            setModalTitle("Error T01");
            setModalBody("Transaction failed.");
        }
        window.$("#exampleModal").modal("show");
    };

    const handleSend = async () => {
        await estado();
        const toWallet = walletInput.current.value;
        const tokenInfo = tokenContratos[idMoneda];
        const tokenInstance = contrato.tokenList[idMoneda];
        const amount = new BigNumber(parseFloat(amountIn)).shiftedBy(tokenInfo.decimals).dp(0);

        if (!tronWeb.isAddress(toWallet) || toWallet === wallet) {
            setModalTitle("Input error");
            setModalBody("Invalid Wallet");
            window.$("#exampleModal").modal("show");
            return;
        }

        if (amount.lte(0)) {
            setModalTitle("Input error");
            setModalBody("Invalid amount");
            window.$("#exampleModal").modal("show");
            return;
        }

        if (!approved) {
            await handleApproval();
            return;
        }

        const balance = new BigNumber(await tokenInstance.balanceOf(wallet).call());
        if (balance.lt(amount)) {
            setModalTitle("Input error");
            setModalBody("Insufficient token balance");
            window.$("#exampleModal").modal("show");
            return;
        }

        if (energyContrato < LIMITE_ENERGY) {
            setModalTitle("Sold Out");
            setModalBody("All resources have been sold. Try again later.");
            window.$("#exampleModal").modal("show");
            return;
        }

        setModalTitle("🔄 Confirm Transaction");
        setModalBody(<>
            This is the recipient's wallet address:<br></br> <b>{toWallet}.</b><br></br><br></br>

            📥 Recipient will receive: <b>{amount.shiftedBy(-tokenInfo.decimals).minus(tokenInfo.fees).toString(10)} {tokenInfo.symbol}</b><br></br>

            🧾 Contract fee applied: <b>{tokenInfo.fees} {tokenInfo.symbol}</b><br></br>
            ----------------------------------------------------------<br></br>
            💸 Total deducted from your wallet: <b>{amount.shiftedBy(-tokenInfo.decimals).toString(10)} {tokenInfo.symbol}</b><br></br><br></br>

            Confirm to proceed with the transfer {imgLoading}.
        </>);
        window.$("#exampleModal").modal("show");

        const trigger = await tronWeb.transactionBuilder.triggerSmartContract(
            window.tronWeb.address.toHex(contrato.ciro_trx.address),
            "transfer(address,uint256,address)",
            {},
            [
                { type: 'address', value: window.tronWeb.address.toHex(toWallet) },
                { type: 'uint256', value: amount.toString(10) },
                { type: 'address', value: window.tronWeb.address.toHex(tokenInfo.address) }
            ],
            window.tronWeb.address.toHex(wallet)
        );

        let tx = await tronWeb.transactionBuilder.extendExpiration(trigger.transaction, 180);
        tx = await adapter.signTransaction(tx).catch((e) => {
            setModalTitle("Transaction failed E-A02");
            setModalBody(e.toString());
            window.$("#exampleModal").modal("show");
            return null;
        });
        if (!tx) return false
        const sentTx = await tronWeb.trx.sendRawTransaction(tx).catch((e) => {
            setModalTitle("Transaction failed E-A03");
            setModalBody(e.toString());
            window.$("#exampleModal").modal("show");
            return null;
        });

        if (!sentTx) return false

        setModalTitle("Waiting for confirmation");
        setModalBody(<>Please wait while the blockchain confirms your transaction {imgLoading}</>);
        window.$("#exampleModal").modal("show");

        await utils.delay(6);
        const txInfo = await tronWeb.trx.getTransaction(sentTx.txid);
        if (txInfo.ret[0].contractRet === "SUCCESS") {
            setModalTitle("Transaction successful");
            setModalBody(<>
                Transfer completed!<br></br><br></br>
                ID Transaction: {sentTx.txid}
                <a href={`https://tronscan.io/#/transaction/${sentTx.txid}`} target="_blank" rel="noreferrer noopener">See on TronScan</a>
            </>);
        } else {
            setModalTitle("Transaction failed");
            setModalBody("An error occurred. Please try again or contact support.");
        }
        window.$("#exampleModal").modal("show");
    };

    const handleChangeToken = (e) => {
        const value = parseInt(e.target.value);
        setIdMoneda(value);
        // Opcional: llamar a estado para actualizar inmediatamente
        estado()
    };

    const handleAmountChange = (e) => {
        let value = e.target.value.replace(",", ".")
        if (parseFloat(value) < 0) {
            value = ''
        }
        setAmounIn(value);
    };

    const handleFillAvailable = () => {
        setAmounIn(tokenBalance)
    }

    const handleBuyPack = async (idPack) => {
        if(!contractReady) {
            setModalTitle("Wallet Error");
            setModalBody("Connect Wallet first.");
            window.$("#exampleModal").modal("show");

            return;
        }

        await estado(); // si esto actualiza la wallet, energía, etc.

        const saleContract = contrato.sale_token; // tu contrato de venta
        const tokenInstance = saleContract.token; // instancia TRC20 de USDD
        const buyerAddress = wallet;

        // === VALIDACIONES BÁSICAS ===
        if (!tronWeb.isAddress(buyerAddress)) {
            setModalTitle("Input error");
            setModalBody("Invalid wallet address.");
            window.$("#exampleModal").modal("show");
            return;
        }

        // === OBTENER EL PRECIO DEL PAQUETE ===
        const packageInfo = await saleContract.packages(idPack).call();
        const price = new BigNumber(packageInfo.price);

        // === VERIFICAR BALANCE ===
        const balance = new BigNumber(await tokenInstance.balanceOf(buyerAddress).call());
        console.log(price.toNumber(), balance.toNumber())

        if (balance.lt(price)) {
            setModalTitle("Input error");
            setModalBody("Insufficient USDD balance.");
            window.$("#exampleModal").modal("show");
            return;
        }

        // === VERIFICAR ALLOWANCE ===
        const allowance = new BigNumber(await tokenInstance.allowance(buyerAddress, saleContract.address).call());
        if (allowance.lt(price)) {
            setModalTitle("🔑 Approving USDD");
            setModalBody("Granting approval to the contract. Please confirm in your wallet.");
            window.$("#exampleModal").modal("show");

            const approveTx = await tokenInstance.approve(saleContract.address, price.toString(10)).send();
            if (!approveTx || !approveTx.txid) {
                setModalTitle("Approval Failed");
                setModalBody("Could not approve USDD. Try again.");
                return;
            }

            setModalTitle("✅ Approval Successful");
            setModalBody(`Approval TX: ${approveTx.txid}`);
            window.$("#exampleModal").modal("show");
            await utils.delay(3);
        }

        // === EJECUTAR LA COMPRA DEL PAQUETE ===

        const decimales = parseInt(await tokenInstance.decimals().call())
        setModalTitle("🔄 Confirm Purchase");
        setModalBody(`Buying pack of #${packageInfo.amount} txn for ${price.shiftedBy(-decimales).toString()} USDD`);
        window.$("#exampleModal").modal("show");

        const trigger = await tronWeb.transactionBuilder.triggerSmartContract(
            tronWeb.address.toHex(saleContract.address),
            "buy(uint256)",
            {},
            [{ type: 'uint256', value: idPack }],
            tronWeb.address.toHex(buyerAddress)
        );

        let tx = await tronWeb.transactionBuilder.extendExpiration(trigger.transaction, 180);
        tx = await adapter.signTransaction(tx).catch((e) => {
            setModalTitle("❌ Signing Failed");
            setModalBody(e.toString());
            return null;
        });
        if (!tx) return;

        const sentTx = await tronWeb.trx.sendRawTransaction(tx).catch((e) => {
            setModalTitle("❌ Sending Failed");
            setModalBody(e.toString());
            return null;
        });
        if (!sentTx) return;

        setModalTitle("⏳ Waiting Confirmation");
        setModalBody("Please wait while the transaction is confirmed...");
        await utils.delay(6);

        const txInfo = await tronWeb.trx.getTransaction(sentTx.txid);
        if (txInfo.ret[0].contractRet === "SUCCESS") {
            setModalTitle("🎉 Purchase Successful");
            setModalBody(
                <>
                    Pack #{idPack} bought successfully!<br />
                    TX ID: <a href={`https://tronscan.io/#/transaction/${sentTx.txid}`} target="_blank" rel="noopener noreferrer">View on Tronscan</a>
                </>
            );
        } else {
            setModalTitle("❌ Purchase Failed");
            setModalBody("The transaction did not succeed. Please try again.");
        }
        window.$("#exampleModal").modal("show");
    };


    const renderButton = () => {
        const baseStyle = {
            width: '100%',
            padding: '1rem',
            border: 'none',
            borderRadius: '2rem',
            fontSize: '1rem',
            fontWeight: '600',
            color: '#ffffff',
            background: approved && parseFloat(recivedAmount) > 0 ? 'linear-gradient(135deg, #00c9a7 0%, #007cf0 100%)' : '#7f8c8d',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 15px rgba(0, 201, 167, 0.4)',
            transition: 'transform 0.2s ease'
        };
        let funcionBoton = () => { }
        if (approved) {
            if (parseFloat(recivedAmount) > 0) {
                funcionBoton = handleSend
            }
        } else {
            funcionBoton = handleApproval
        }

        let textoBoton = (<>Connect Wallet</>)


        if (estatus && estatus.loggedIn) {

            textoBoton = approved ? (<><span style={{ marginRight: '0.5rem' }} role='img' aria-label="rocket">🚀</span>
                Send {recivedAmount} {tokenSelected}</>) : (<>Approval spend {tokenSelected}</>)

        } else {
            funcionBoton = conectar
        }


        return (
            <button type="button" style={baseStyle} onClick={funcionBoton}>
                {textoBoton}
            </button>
        )
    };

    const energyStatusIcon = porcentajeE.dp(2).toNumber() < 10 ? "🔴" : porcentajeE.dp(2).toNumber() < 20 ? "🟡" : porcentajeE.dp(2).toNumber() < 80 ? "🟢" : "🔵";

    return (
        <>
            <style>{`
            select,
            select option {
                background-color: #162c44;
                color: #ffffff;
            }
            select:focus {
                outline: none;
                border: 1px solid #1DD1A1;
            }
            ::placeholder {
            color: #b0bec5;
            opacity: 1;
            }
            input::placeholder {
            color: #b0bec5;
            }
            @media (max-width: 992px) {
                .form-row-responsive {
                    flex-direction: column;
                    align-items: center;
                    gap: 2rem;
                }
            }
            `}</style>

            <div className="contact-form-area style-two pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="dreamit-section-title text-center upper1 pb-70">
                            <div className="alert alert-success" role="alert">
                                <strong> {"🔄"} New smarter contract</strong> — approve once for more features.
                            </div>
                            <h4>CiroTrx by Brutus.Finance</h4>
                            <h1 className="section-title">Stablecoin on TRON made simple</h1>

                        </div>
                    </div>
                    <div className="row form-row-responsive" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="col-lg-5 order-2 order-md-1 d-flex justify-content-center mb-4 mb-lg-0" >
                            <img src="assets/images/resource/CIROTRX.png" alt="ciro trx" />
                        </div>
                        <div className="col-lg-7 order-1 order-md-2 d-flex justify-content-center">
                            <form id="dreamit-form" style={{ width: '100%', maxWidth: '500px', background: '#11263c', borderRadius: '1rem', padding: '2rem', boxShadow: '0 0 15px rgba(0,0,0,0.3)' }}>


                                <h2 style={{ fontWeight: 'bold', color: '#ffffff' }}>CiroTrx</h2>
                                <p style={{ marginBottom: '1.5rem', color: '#9ab4c0' }}>
                                    Status: <span style={{ color: '#27ae60' }}>{energyStatusIcon} {porcentajeE.dp(2).toString(10)}% ({energyContrato.toLocaleString('en-US')} Energy)</span>
                                </p>

                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#9ab4c0', cursor: 'default' }}>Recipient wallet</label>
                                <input type="text" ref={walletInput} placeholder="Paste or enter the account address"
                                    style={{ width: '100%', padding: '0.75rem 1rem', borderRadius: '0.75rem', border: 'none', backgroundColor: '#162c44', color: 'white', marginBottom: '1.5rem' }} />

                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#9ab4c0', cursor: 'default' }}>Choose a stablecoin</label>
                                <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#162c44', borderRadius: '0.75rem', marginBottom: '1.5rem' }}>
                                    <img src={`assets/images/${tokenSelected}-logo.png`} alt={`${tokenSelected}-logo`} style={{ height: '40px', margin: '0.5rem' }} />
                                    <select value={idMoneda} onChange={handleChangeToken} style={{ flexGrow: 1, padding: '0.75rem 1rem', border: 'none', borderRadius: '0.75rem', backgroundColor: 'transparent', color: '#ffffff' }}>
                                        {tokenContratos.map((token, idx) => (
                                            <option key={token.symbol} value={idx}>{token.symbol} ({token.name}) - Fee {token.fees} {token.symbol}</option>
                                        ))}
                                    </select>
                                </div>

                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#9ab4c0' }} onClick={() => handleFillAvailable()}>Available: {tokenBalance.toString(10)} {tokenSelected}</label>
                                <input type="text" ref={amountInput} value={amountIn} onChange={handleAmountChange}
                                    placeholder={`0.0 ${tokenSelected}`} style={{ width: '100%', padding: '0.75rem 1rem', borderRadius: '0.75rem', border: 'none', backgroundColor: '#162c44', color: 'white', marginBottom: '1.5rem' }} />

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
                                    {[0.25, 0.5, 0.75, 1].map((fraction, idx) => (
                                        <button
                                            key={idx}
                                            type="button"
                                            onClick={() => setAmounIn(tokenBalance.times(fraction).dp(6).toString(10))}
                                            style={{ flex: 1, margin: '0 5px', backgroundColor: '#1DD1A1', color: 'white', padding: '0.5rem', borderRadius: '10px', border: 'none' }}>
                                            {fraction * 100}%
                                        </button>
                                    ))}
                                </div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#ffffff', cursor: 'default' }}><span role="img" aria-label="alert">⚠️</span> Recipient gets amount minus {tokenContratos[idMoneda].fees} {tokenSelected} fee</label>

                                <div style={{ marginBottom: '1rem' }}>
                                    {renderButton()}
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>



            <div className="pricing-area pt-100 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="dreamit-section-title upper1 text-center pb-40">
                                <h4>Save More</h4>
                                <h1 className="section-title">Pricing Plan</h1>
                                <p className="section-text">Buy now, use later. The more you buy, the less you pay per transaction.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12 pt-left pl-0 pr-0">
                            <div className="pricing-single-box">

                                <div className="pricing-top-ber">
                                    <div className="pricing-head">
                                        <div className="pricing-title">
                                            <h3>Starter</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="pricing-items">
                                    <div className="pricing-items-title">
                                        <p>Great for testing or occasional users</p>
                                    </div>
                                    <div className="pricing-items-center">
                                        <span className="curencyp">$</span>
                                        <span className="tk">2.5</span>
                                        <span className="monthp"> $0.41/txn</span>
                                    </div>
                                </div>

                                <div className="pricing-boody">
                                    <div className="pricing-featur">
                                        <ul>
                                            <li><span><i className="fas fa-check"></i></span> 5 Transactions</li>
                                            <li><span><i className="fas fa-check"></i></span> +1 aditional Transactions</li>
                                        </ul>
                                    </div>
                                    <div className="pricing-button" onClick={() => { handleBuyPack(0) }}>
                                        <a href='#purachesNow'>Purches Now</a>
                                    </div>
                                    <div className="pricing-hide"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 pt-left pl-0 pr-0">
                            <div className="pricing-single-box active">

                                <div className="pricing-top-ber">
                                    <div className="pricing-head">
                                        <div className="pricing-title">
                                            <h3>Pro</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="pricing-items">
                                    <div className="pricing-items-title">
                                        <p>Designed for active users</p>
                                    </div>
                                    <div className="pricing-items-center">
                                        <span className="curencyp">$</span>
                                        <span className="tk">15</span>
                                        <span className="monthp"> $0.40/txn</span>
                                    </div>
                                </div>

                                <div className="pricing-boody">
                                    <div className="pricing-featur">
                                        <ul>
                                            <li><span><i className="fas fa-check"></i></span> 30 Transactions</li>
                                            <li><span><i className="fas fa-check"></i></span> +7 aditional Transactions</li>

                                        </ul>
                                    </div>
                                    <div className="pricing-button" onClick={() => { handleBuyPack(1) }}>
                                        <a href='#purachesNow'>Purches Now</a>
                                    </div>
                                    <div className="pricing-hide"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 pt-left pl-0 pr-0">
                            <div className="pricing-single-box">

                                <div className="pricing-top-ber">
                                    <div className="pricing-head">
                                        <div className="pricing-title">
                                            <h3>Business</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="pricing-items">
                                    <div className="pricing-items-title">
                                        <p>Perfect for automation</p>
                                    </div>
                                    <div className="pricing-items-center">
                                        <span className="curencyp">$</span>
                                        <span className="tk">25</span>
                                        <span className="monthp"> $0.38/txn</span>
                                    </div>
                                </div>

                                <div className="pricing-boody">
                                    <div className="pricing-featur">
                                        <ul>
                                            <li><span><i className="fas fa-check"></i></span> 50 Transactions</li>
                                            <li><span><i className="fas fa-check"></i></span> +15 aditional Transactions</li>

                                        </ul>
                                    </div>
                                    <div className="pricing-button" onClick={() => { handleBuyPack(2) }}>
                                        <a href='#purachesNow'>Purches Now</a>
                                    </div>
                                    <div className="pricing-hide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*<button onClick={()=>adapter.connect()}>Connect Wallet</button>*/}

            {/*<div className="contact-form-area style-two pt-100 pb-100">
                <h1>Escáner de QR</h1>
                 <div>
            <QRScanner />
            </div>  
                {qrResult && <p>Resultado: {qrResult}</p>}
            </div>*/}

            <div className="modal" id="exampleModal" style={{ zIndex: 999 }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-dark">{modalTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {modalBody}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CiroTrx;